import { Injectable } from '@angular/core'
import { MbCheckoutContactDetailsFacade } from '../facades/mb-checkout-contact-details.facade'
import {
  CommandService, EventService,
  GlobalMessageService,
  GlobalMessageType,
  UserIdService
} from '@spartacus/core'
import { MbCheckoutContactDetailsModel } from '../../models'
import { catchError, switchMap, take, tap } from 'rxjs/operators'
import { ActiveCartFacade } from '@spartacus/cart/base/root'
import { MbCheckoutContactDetailsConnector } from '../connectors'
import { combineLatest, EMPTY } from 'rxjs'
import { CheckoutContactDetailsSetEvent } from '../../analytics/events/mb-checkout.events'

@Injectable({
  providedIn: 'root'
})
export class MbCheckoutContactDetailsService implements MbCheckoutContactDetailsFacade {

  constructor (protected userIdService: UserIdService,
               protected activeCartService: ActiveCartFacade,
               protected globalMessageService: GlobalMessageService,
               protected commandService: CommandService,
               protected eventService: EventService,
               protected mbCheckoutContactDetailsConnector: MbCheckoutContactDetailsConnector) {
  }

  createAndSetContactDetails (contactDetails?: MbCheckoutContactDetailsModel) {
    if (!contactDetails) {
      this.globalMessageService.add({ key: 'contact.error' }, GlobalMessageType.MSG_TYPE_ERROR)
      return
    }
    this.commandService.create(() =>
      combineLatest([this.userIdService.takeUserId(), this.activeCartService.takeActiveCartId()]).pipe(
        take(1),
        switchMap(([userId, cartId]) => this.mbCheckoutContactDetailsConnector.post(contactDetails, cartId).pipe(
          tap(() => this.eventService.dispatch({ isSuccessful: true }, CheckoutContactDetailsSetEvent)),
          catchError(error => {
            this.eventService.dispatch({ isSuccessful: false, error: error }, CheckoutContactDetailsSetEvent)
            return EMPTY
          })
        ))
      )).execute(undefined)
  }
}
